import { put, takeEvery, call, takeLatest } from "redux-saga/effects";
import { commonConstants, alertsConstants } from "../../constants";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { alerts, alertActions } from "../../actions";

function* alertListing(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.alertsUrl.list,
      action.payload
    );

    if (data.status === true) {
      let totalRecords =
        (data.data &&
          data.data.pagination_options &&
          data.data.pagination_options.total_count) ||
        0;
      let totalpages = Math.ceil(
        parseInt(totalRecords) / commonConstants.recordsPerPage
      );

      yield put(
        alerts.alertListingSuccess({
          list: data.data && data.data.list,
          paginationOptions: {
            totalpages,
            currentpage: action.payload.page,
            totalRecords,
            limit_per_page: commonConstants.recordsPerPage
          }
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* alertSave(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.alertsUrl.save,
      action.payload
    );

    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(
        alerts.alertSaveSuccess()
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* alertDelete(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.alertsUrl.delete,
      action.payload
    );

    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(
        alerts.alertDeleteSuccess()
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

export function* alertsSaga() {
  yield takeLatest(alertsConstants.ALERT_LISTING_REQUEST, alertListing);
  yield takeEvery(alertsConstants.ALERT_SAVE_REQUEST, alertSave);
  yield takeEvery(alertsConstants.ALERT_DELETE_REQUEST, alertDelete);
}
